<template>
  <div id="page-worldcup-predict">
    <!-- ==================== ตาราง 1 : ตรวจสอบรูปที่ส่งเข้ามา ==================== -->
    <vx-card class="mb-8">
      <div class="vx-card__title mb-4">
        <h4>1. ตรวจสอบรูปที่ส่งเข้ามา (รออนุมัติ)</h4>
        <span class="text-sm" style="color: rgba(255,255,255,.6)"
          >กดดูรูปเพื่อตรวจสอบ แล้วกด "อนุมัติ" รายการจะถูกย้ายลงตารางที่ 2</span
        >
      </div>

      <div class="flex flex-wrap items-center justify-between mb-2">
        <div class="flex flex-wrap items-center">
          <span class="mr-3 text-sm">เลือกแล้ว {{ selected.length }} รายการ</span>
          <vs-button
            class="mr-2 mb-1"
            :disabled="!canEdit || selected.length === 0"
            size="small"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            @click="openBulk('approve')"
            >อนุมัติที่เลือก</vs-button
          >
          <vs-button
            class="mr-2 mb-1"
            :disabled="!canEdit || selected.length === 0"
            size="small"
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            @click="openBulk('reject')"
            >ปฏิเสธที่เลือก</vs-button
          >
        </div>
        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-refresh-cw"
          color="success"
          @click="getPending()"
          >รีเฟรช</vs-button
        >
      </div>

      <vs-table stripe pagination max-items="10" search :data="pendingData">
        <template slot="thead">
          <vs-th>
            <vs-checkbox v-model="allSelected" />
          </vs-th>
          <vs-th sort-key="created_at">วันที่ส่ง</vs-th>
          <vs-th sort-key="username">ยูสเซอร์เนม</vs-th>
          <vs-th sort-key="country">ประเทศที่ทาย</vs-th>
          <vs-th>รูปภาพ</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selected" :vs-value="tr.no" />
            </vs-td>
            <vs-td :data="tr.created_at">
              {{ tr.created_at ? moment(tr.created_at).format("YYYY-MM-DD HH:mm:ss") : "-" }}
            </vs-td>
            <vs-td class="text-danger" :data="tr.username">
              <router-link :to="`/member/${tr.username}`">{{ tr.username }}</router-link>
            </vs-td>
            <vs-td :data="tr.country">
              <span class="flex items-center">
                <img
                  v-if="countryFlag(tr.country)"
                  :src="countryFlag(tr.country)"
                  class="mr-2"
                  style="width: 24px; height: 18px; object-fit: cover; border-radius: 2px"
                />
                {{ countryName(tr.country) }}
              </span>
            </vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="rgb(115, 103, 240)"
                type="filled"
                icon-pack="feather"
                icon="icon-image"
                @click="openImages(tr)"
                >ดูรูป</vs-button
              >
            </vs-td>
            <vs-td>
              <div class="flex items-center" style="white-space: nowrap">
                <vs-button
                  :disabled="!canEdit"
                  class="mr-2"
                  size="small"
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-check"
                  @click="confirmAction(tr, 'approve')"
                  >อนุมัติ</vs-button
                >
                <vs-button
                  :disabled="!canEdit"
                  size="small"
                  color="danger"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-x"
                  @click="confirmAction(tr, 'reject')"
                  >ปฏิเสธ</vs-button
                >
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- ==================== ตาราง 2 : ผ่านกติกา (status success) ==================== -->
    <vx-card class="mb-8">
      <div class="vx-card__title mb-4">
        <h4>2. รายชื่อที่ผ่านกติกา (success)</h4>
        <span class="text-sm" style="color: rgba(255,255,255,.6)"
          >เลือกกรองตามประเทศ / ค้นหายูส และกำหนด rating + รางวัลให้แต่ละคน</span
        >
      </div>

      <!-- ปุ่ม filter ประเทศ (มีจำนวนข้างใน) -->
      <div class="flex flex-wrap items-center mb-4">
        <vs-button
          class="mr-2 mb-2"
          size="small"
          :type="selectedCountry === '' ? 'filled' : 'border'"
          :color="selectedCountry === '' ? 'primary' : 'rgb(150, 150, 150)'"
          @click="selectedCountry = ''"
          >ทั้งหมด ({{ successData.length }})</vs-button
        >
        <vs-button
          v-for="c in countryCounts"
          :key="c.name"
          class="mr-2 mb-2"
          size="small"
          :type="selectedCountry === c.name ? 'filled' : 'border'"
          :color="selectedCountry === c.name ? 'primary' : 'rgb(150, 150, 150)'"
          @click="toggleCountry(c.name)"
        >
          <span class="flex items-center">
            <img
              v-if="countryFlag(c.name)"
              :src="countryFlag(c.name)"
              class="mr-1"
              style="width: 18px; height: 14px; object-fit: cover; border-radius: 2px"
            />
            {{ countryName(c.name) }} ({{ c.count }})
          </span>
        </vs-button>
      </div>

      <!-- ค้นหา username -->
      <div class="flex flex-wrap items-center mb-4 justify-between">
        <vs-input
          icon-pack="feather"
          icon="icon-search"
          placeholder="ค้นหายูสเซอร์เนม"
          v-model="searchSuccess"
          class="mb-2"
        />
        <vs-button
          size="small"
          icon-pack="feather"
          icon="icon-refresh-cw"
          color="success"
          @click="getSuccess()"
          >รีเฟรช</vs-button
        >
      </div>

      <vs-table stripe pagination max-items="20" :data="filteredSuccess">
        <template slot="thead">
          <vs-th sort-key="created_at">วันที่ส่ง</vs-th>
          <vs-th sort-key="username">ยูสเซอร์เนม</vs-th>
          <vs-th sort-key="country">ประเทศที่ทาย</vs-th>
          <vs-th sort-key="rating">Rating</vs-th>
          <vs-th sort-key="rewards">รางวัล</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.created_at">
              {{ tr.created_at ? moment(tr.created_at).format("YYYY-MM-DD HH:mm:ss") : "-" }}
            </vs-td>
            <vs-td class="text-danger" :data="tr.username">
              <router-link :to="`/member/${tr.username}`">{{ tr.username }}</router-link>
            </vs-td>
            <vs-td :data="tr.country">
              <span class="flex items-center">
                <img
                  v-if="countryFlag(tr.country)"
                  :src="countryFlag(tr.country)"
                  class="mr-2"
                  style="width: 24px; height: 18px; object-fit: cover; border-radius: 2px"
                />
                {{ countryName(tr.country) }}
              </span>
            </vs-td>
            <vs-td :data="tr.rating">
              <vs-chip v-if="isRated(tr)" color="warning">อันดับ {{ tr.rating }}</vs-chip>
              <span v-else>-</span>
            </vs-td>
            <vs-td :data="tr.rewards">{{ tr.rewards || "-" }}</vs-td>
            <vs-td>
              <vs-button
                :disabled="!canEdit"
                size="small"
                color="warning"
                type="filled"
                icon-pack="feather"
                icon="icon-edit"
                @click="openRating(tr)"
                >ตั้ง Rating / รางวัล</vs-button
              >
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- ==================== ตาราง 3 : เรียงตาม rating ==================== -->
    <vx-card class="mb-8">
      <div class="vx-card__title mb-4">
        <h4>3. ผลอันดับ (เรียงตาม Rating น้อย → มาก)</h4>
      </div>

      <vs-table stripe pagination max-items="20" :data="rankingData">
        <template slot="thead">
          <vs-th sort-key="rating">อันดับ (Rating)</vs-th>
          <vs-th sort-key="username">ยูสเซอร์เนม</vs-th>
          <vs-th sort-key="country">ประเทศที่ทาย</vs-th>
          <vs-th sort-key="rewards">รางวัล</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.rating">
              <vs-chip color="warning">{{ tr.rating }}</vs-chip>
            </vs-td>
            <vs-td class="text-danger" :data="tr.username">
              <router-link :to="`/member/${tr.username}`">{{ tr.username }}</router-link>
            </vs-td>
            <vs-td :data="tr.country">
              <span class="flex items-center">
                <img
                  v-if="countryFlag(tr.country)"
                  :src="countryFlag(tr.country)"
                  class="mr-2"
                  style="width: 24px; height: 18px; object-fit: cover; border-radius: 2px"
                />
                {{ countryName(tr.country) }}
              </span>
            </vs-td>
            <vs-td :data="tr.rewards">{{ tr.rewards || "-" }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <!-- ==================== POPUP : ดูรูป ==================== -->
    <vs-popup
      classContent="popup-images"
      :title="`รูปที่ส่งเข้ามาของ ${imageUser}`"
      :active.sync="popupImages"
    >
      <div v-if="imageLoading" class="text-center p-6">กำลังโหลดรูป...</div>
      <div v-else-if="imageList.length === 0" class="text-center p-6">ไม่พบรูปภาพ</div>
      <div v-else class="flex flex-wrap">
        <div
          v-for="(img, idx) in imageList"
          :key="idx"
          class="w-full sm:w-1/2 p-2"
        >
          <a :href="img" target="_blank" rel="noopener">
            <img :src="img" class="w-full rounded" style="border: 1px solid rgba(255,255,255,.15)" />
          </a>
          <p class="text-center text-sm mt-1">รูปที่ {{ idx + 1 }}</p>
        </div>
      </div>
    </vs-popup>

    <!-- ==================== POPUP : อนุมัติ / ปฏิเสธ (ทีละรายการ) ==================== -->
    <vs-popup
      classContent="popup-example"
      :title="actionType === 'approve' ? 'ยืนยันการอนุมัติ' : 'ยืนยันการปฏิเสธ'"
      :active.sync="popupAction"
    >
      <div class="p-2">
        <p class="mb-4">
          {{ actionType === 'approve' ? 'ยืนยันอนุมัติยูสเซอร์' : 'ยืนยันปฏิเสธยูสเซอร์' }}
          <span class="text-danger">{{ actionRow.username }}</span>
          {{ actionType === 'approve' ? ' ให้ผ่านกติกา (ย้ายลงตารางที่ 2)?' : ' (สถานะจะเป็น fail)?' }}
        </p>
        <div class="text-center">
          <vs-button
            :disabled="!canEdit"
            :color="actionType === 'approve' ? 'success' : 'danger'"
            type="filled"
            @click="runSingle()"
            >{{ actionType === 'approve' ? 'ยืนยันอนุมัติ' : 'ยืนยันปฏิเสธ' }}</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <!-- ==================== POPUP : อนุมัติ / ปฏิเสธ ทั้งหมดที่เลือก ==================== -->
    <vs-popup
      classContent="popup-example"
      :title="bulkAction === 'approve' ? 'อนุมัติรายการที่เลือก' : 'ปฏิเสธรายการที่เลือก'"
      :active.sync="popupBulk"
    >
      <!-- ขั้นยืนยัน -->
      <div v-if="!bulkRunning && !bulkFinished" class="p-2">
        <p class="mb-4">
          ยืนยัน{{ bulkAction === 'approve' ? 'อนุมัติ' : 'ปฏิเสธ' }}ทั้งหมด
          <span class="text-danger">{{ selected.length }}</span> รายการ?
        </p>
        <div class="text-center">
          <vs-button
            :disabled="!canEdit"
            :color="bulkAction === 'approve' ? 'success' : 'danger'"
            type="filled"
            @click="runBulk()"
            >เริ่มทำรายการ</vs-button
          >
        </div>
      </div>

      <!-- ขั้นกำลังทำรายการ + หลอดโหลด -->
      <div v-else class="p-2">
        <p class="mb-2 text-center">
          กำลังทำรายการ {{ bulkDone }}/{{ bulkTotal }}
          <span v-if="bulkFinished"> (เสร็จสิ้น)</span>
        </p>
        <vs-progress :percent="bulkPercent" :color="bulkAction === 'approve' ? 'success' : 'danger'">
          progress
        </vs-progress>
        <p v-if="bulkFinished" class="mt-4 text-center">
          สำเร็จ <span class="text-success">{{ bulkSuccess }}</span> รายการ
          / ไม่สำเร็จ <span class="text-danger">{{ bulkFail }}</span> รายการ
        </p>
        <div v-if="bulkFinished" class="text-center mt-4">
          <vs-button color="primary" type="filled" @click="closeBulk()">ปิด</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- ==================== POPUP : ตั้ง Rating / รางวัล ==================== -->
    <vs-popup
      classContent="popup-example"
      :title="`ตั้ง Rating / รางวัล : ${ratingForm.username}`"
      :active.sync="popupRating"
    >
      <div class="p-2">
        <label class="vs-input--label">Rating (อันดับ เช่น 1, 2, 3 ...)</label>
        <vs-input
          type="number"
          min="1"
          placeholder="ใส่อันดับเป็นตัวเลข"
          v-model="ratingForm.rating"
          class="w-full mb-4"
        />

        <label class="vs-input--label">รางวัล</label>
        <vs-input
          placeholder="ชื่อ/ข้อความรางวัล"
          v-model="ratingForm.rewards"
          class="w-full mb-6"
        />

        <div class="text-center">
          <vs-button :disabled="!canEdit" color="primary" type="filled" @click="saveRating()"
            >บันทึก</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from '../../axios'
import moment from 'moment'
import { countryName, countryFlag } from './countries'

export default {
  data () {
    return {
      url: process.env.VUE_APP_AWS3_URL,
      // ตาราง 1
      pendingData: [],
      // ตาราง 2
      successData: [],
      selectedCountry: '',
      searchSuccess: '',
      // เลือกหลายรายการ (ตาราง 1)
      selected: [],
      // popup ดูรูป
      popupImages: false,
      imageUser: '',
      imageList: [],
      imageLoading: false,
      // popup อนุมัติ/ปฏิเสธ ทีละรายการ
      popupAction: false,
      actionType: 'approve',
      actionRow: { no: null, username: '', country: '' },
      // popup อนุมัติ/ปฏิเสธ ทั้งหมดที่เลือก
      popupBulk: false,
      bulkAction: 'approve',
      bulkRunning: false,
      bulkFinished: false,
      bulkTotal: 0,
      bulkDone: 0,
      bulkSuccess: 0,
      bulkFail: 0,
      // popup rating
      popupRating: false,
      ratingForm: { no: null, username: '', rating: '', rewards: '' }
    }
  },
  computed: {
    canEdit () {
      // ใช้สิทธิ์ชุดเดียวกับเมนู prediction (อิงตามที่ระบบเปิดให้เข้าถึงหน้านี้)
      return true
    },
    // checkbox หัวตาราง : เลือก/ยกเลิกทั้งหมด
    allSelected: {
      get () {
        return this.pendingData.length > 0 && this.selected.length === this.pendingData.length
      },
      set (val) {
        this.selected = val ? this.pendingData.map(r => r.no) : []
      }
    },
    // เปอร์เซ็นต์หลอดโหลด bulk
    bulkPercent () {
      return this.bulkTotal > 0 ? Math.round((this.bulkDone / this.bulkTotal) * 100) : 0
    },
    // นับจำนวนแยกตามประเทศ สำหรับปุ่ม filter
    countryCounts () {
      const map = {}
      this.successData.forEach(d => {
        const name = d.country || 'ไม่ระบุ'
        map[name] = (map[name] || 0) + 1
      })
      return Object.keys(map)
        .map(name => ({ name, count: map[name] }))
        .sort((a, b) => b.count - a.count)
    },
    // ตาราง 2 หลังกรองประเทศ + ค้นหายูส
    filteredSuccess () {
      const q = this.searchSuccess.trim().toLowerCase()
      return this.successData.filter(d => {
        const matchCountry = this.selectedCountry === '' || (d.country || 'ไม่ระบุ') === this.selectedCountry
        const matchSearch = q === '' || (d.username || '').toLowerCase().includes(q)
        return matchCountry && matchSearch
      })
    },
    // ตาราง 3 : เฉพาะคนที่ตั้ง rating แล้ว เรียงน้อย → มาก
    rankingData () {
      return this.successData
        .filter(d => this.isRated(d))
        .slice()
        .sort((a, b) => Number(a.rating) - Number(b.rating))
    }
  },
  methods: {
    moment,
    countryName,
    countryFlag,
    toggleCountry (name) {
      // กดประเทศเดิมซ้ำ = ล้าง filter กลับไปแสดงทั้งหมด
      this.selectedCountry = this.selectedCountry === name ? '' : name
    },
    isRated (row) {
      return row.rating !== null && row.rating !== undefined && row.rating !== '' && !isNaN(Number(row.rating))
    },
    notify (success, title, text) {
      this.$vs.notify({
        time: success ? 3000 : 8000,
        color: success ? 'success' : 'danger',
        position: 'top-right',
        icon: success ? 'check_box' : 'error',
        title,
        text: text || ''
      })
    },
    // ----- ตาราง 1 -----
    async getPending () {
      await axios
        .get('prediction/worldcup/pending')
        .then(response => (this.pendingData = response.data))
        .catch(() => this.notify(false, 'โหลดรายการรออนุมัติไม่สำเร็จ'))
    },
    // แปลงค่าใน column images (text) เป็น list ของ URL รูป
    buildImageUrls (row) {
      const raw = row.images
      if (!raw) return []
      let items = []
      try {
        // รองรับกรณีเก็บเป็น JSON array
        const parsed = JSON.parse(raw)
        items = Array.isArray(parsed) ? parsed : [String(parsed)]
      } catch (e) {
        // หรือเก็บเป็นข้อความคั่นด้วย comma
        items = String(raw).split(',')
      }
      return items
        .map(s => String(s).trim())
        .filter(Boolean)
        .map(s => {
          return /^https?:\/\//.test(s) ? s : `${this.url}${s.replace(/^\/+/, '')}`
        })
    },
    // เปิดดูรูปจาก column images
    openImages (row) {
      this.imageUser = row.username
      this.imageList = this.buildImageUrls(row)
      this.imageLoading = false
      this.popupImages = true
    },
    // endpoint ตามชนิด action
    endpointFor (action) {
      return action === 'approve' ? 'prediction/worldcup/approve' : 'prediction/worldcup/reject'
    },
    // ยิง 1 รายการ คืน { ok, info }
    async postAction (action, no) {
      try {
        const res = await axios.post(this.endpointFor(action), { no })
        return { ok: res.data && res.data.status === true, info: (res.data && res.data.info) || '' }
      } catch (e) {
        // ดึงสาเหตุจริงจาก response เช่น 404 (ยังไม่มี route) / 500
        const code = e.response ? e.response.status : ''
        const msg = (e.response && e.response.data && e.response.data.info) || e.message || ''
        return { ok: false, info: `${code} ${msg}`.trim() }
      }
    },
    // ----- อนุมัติ/ปฏิเสธ ทีละรายการ -----
    confirmAction (row, action) {
      this.actionType = action
      this.actionRow = { no: row.no, username: row.username, country: row.country }
      this.popupAction = true
    },
    async runSingle () {
      this.popupAction = false
      const label = this.actionType === 'approve' ? 'อนุมัติ' : 'ปฏิเสธ'
      const res = await this.postAction(this.actionType, this.actionRow.no)
      if (res.ok) {
        this.notify(true, `${label} ${this.actionRow.username} สำเร็จ`)
        // เอาออกจากรายการที่เลือกถ้ามี
        this.selected = this.selected.filter(no => no !== this.actionRow.no)
        await this.getPending()
        await this.getSuccess()
      } else {
        this.notify(false, `${label} ${this.actionRow.username} ไม่สำเร็จ`, res.info)
      }
    },
    // ----- อนุมัติ/ปฏิเสธ ทั้งหมดที่เลือก -----
    openBulk (action) {
      if (this.selected.length === 0) return
      this.bulkAction = action
      this.bulkRunning = false
      this.bulkFinished = false
      this.bulkTotal = 0
      this.bulkDone = 0
      this.bulkSuccess = 0
      this.bulkFail = 0
      this.popupBulk = true
    },
    async runBulk () {
      // snapshot กันรายการเปลี่ยนระหว่างทำงาน
      const list = this.selected.slice()
      this.bulkRunning = true
      this.bulkFinished = false
      this.bulkTotal = list.length
      this.bulkDone = 0
      this.bulkSuccess = 0
      this.bulkFail = 0
      // ยิงทีละตัวแบบ sequential เพื่ออัปเดตหลอดโหลด 1/N
      let lastError = ''
      for (let i = 0; i < list.length; i++) {
        const res = await this.postAction(this.bulkAction, list[i])
        if (res.ok) {
          this.bulkSuccess++
        } else {
          this.bulkFail++
          lastError = res.info
        }
        this.bulkDone++
      }
      // ถ้ามีรายการไม่สำเร็จ โชว์สาเหตุล่าสุดให้เห็น
      if (this.bulkFail > 0 && lastError) {
        this.notify(false, `มี ${this.bulkFail} รายการไม่สำเร็จ`, lastError)
      }
      this.bulkRunning = false
      this.bulkFinished = true
      // เคลียร์เฉพาะรายการที่ทำสำเร็จออกจาก selected
      this.selected = []
      await this.getPending()
      await this.getSuccess()
    },
    closeBulk () {
      this.popupBulk = false
      this.bulkFinished = false
    },
    // ----- ตาราง 2 -----
    async getSuccess () {
      await axios
        .get('prediction/worldcup/success')
        .then(response => (this.successData = response.data))
        .catch(() => this.notify(false, 'โหลดรายชื่อที่ผ่านกติกาไม่สำเร็จ'))
    },
    openRating (row) {
      this.ratingForm = {
        no: row.no,
        username: row.username,
        rating: (row.rating !== null && row.rating !== undefined) ? row.rating : '',
        rewards: row.rewards || ''
      }
      this.popupRating = true
    },
    async saveRating () {
      this.popupRating = false
      let status = {}
      await axios
        .post('prediction/worldcup/rating', {
          no: this.ratingForm.no,
          rating: this.ratingForm.rating === '' ? null : Number(this.ratingForm.rating),
          rewards: this.ratingForm.rewards
        })
        .then(response => (status = response.data))
        .catch(() => (status = { status: false }))
      if (status.status === true) {
        this.notify(true, `บันทึก rating/รางวัลของ ${this.ratingForm.username} สำเร็จ`)
        await this.getSuccess()
      } else {
        this.notify(false, `บันทึก rating/รางวัลของ ${this.ratingForm.username} ไม่สำเร็จ`)
      }
    }
  },
  async mounted () {
    await this.getPending()
    await this.getSuccess()
  }
}
</script>
